/**
 * Shared Web Event Emitter
 *
 * Typed event emitter for web platform speech events.
 * Replaces the inline emitter in AzureSpeech.ts and the local
 * eventListeners map + window.__azureSpeechWebEmitter global
 * in NativeAzureSpeech.web.ts.
 *
 * Single source of truth for web event routing — both
 * NativeAzureSpeech.web.ts (emitter) and AzureSpeech.ts (subscriber)
 * import from here.
 */

import type { RecognitionEvent } from './NativeAzureSpeech';

type Listener = (event: RecognitionEvent) => void;

const listeners: Record<string, Listener[]> = {};

export const webEventEmitter = {
  addListener(eventName: string, callback: Listener) {
    if (!listeners[eventName]) {
      listeners[eventName] = [];
    }
    listeners[eventName].push(callback);

    return {
      remove: () => {
        const index = listeners[eventName]?.indexOf(callback);
        if (index !== undefined && index > -1) {
          listeners[eventName].splice(index, 1);
        }
      },
    };
  },

  emit(eventName: string, event: RecognitionEvent) {
    const cbs = listeners[eventName] || [];
    cbs.forEach((cb) => cb(event));
  },
};
